import { TicketBulkAssigneeUpdate } from './ticket-bulk-assignee-update.model';

export class TicketBulkAssignOperationModel {
    newAssigneeId: string;
    ticketsToUpdate: TicketBulkAssigneeUpdate[];
}
